import { createTheme, ThemeProvider } from '@mui/material/styles';
import { colorSchemes, customShadows, shadows, typography } from '@theme';
import { components } from '@theme/components';

const theme = createTheme({
  colorSchemes,
  typography,
  shadows: shadows('light'),
  customShadows: customShadows('light'),
  shape: { borderRadius: 8 },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 50,
          padding: '10px 30px',
        },
      },
    },
    ...components,
  },
  props: {
    MuiButtonBase: {
      disableRipple: false,
    },
    MuiPopover: {
      elevation: 1,
    },
  },
});

export function MaterialThemeProvider(props) {
  const { children } = props;

  return (
    <ThemeProvider defaultMode="light" theme={theme}>
      {children}
    </ThemeProvider>
  );
}
